import React, { PropTypes } from 'react';
import Modal from 'components/UI/Modal';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';

import _ from 'lodash';

const ALLOW_DESELECT = true;

class ModalBody extends React.Component {
  constructor(props){
    super(props)
    this._onSelect = this._onSelect.bind(this);

    this.state = {
      selected: props.selected || [],
    }
  }

  static propTypes = {
    headerTitle: PropTypes.string.isRequired,
    headerIcon: PropTypes.string.isRequired,
    selectMultiple: PropTypes.bool,
  }

  _onSelect(items) {
    let {
      selectMultiple,
      proceed,
      onConfirm,
    } = this.props;

    const {
      selected,
    } = this.state;

    if (!selectMultiple) {
      // If we don't allow selecting multiple, we remove the items that's already in state.selected and only
      // pick the one that is not in the state.selected. Here is a bit TRICKY.

      // LOGIC 1. If this.state.selected is empty, we assume the first item if items is the one
      // we selected.
      let returnItem;
      if (selected.length === 0) {
        returnItem = items[0];
      } else {
        // LOGIC 2.
        // Because selectList is adding a new select by push(), the newest item will always be the
        // last one at index of items.length - 1.
        if (items.length > 1) {
          returnItem = items[items.length - 1];
        }

        // LOGIC 3.
        // If the items has 0 length, it means we chose the "same" item. In this case
        // it means we're deselecting the item. So if allowDeselect is 'true', we should return
        // an empty array
        if (items.length === 0) {
          returnItem = null;
        }
      }

      if (returnItem) {
        this.setState({
          selected: [returnItem]
        }, this.onConfirm)
      } else {
        this.setState({
          selected: []
        }, this.onConfirm)
      }
    } else {
      // If we allowed selecting multiple items, we just return items in array
      this.setState({
        selected: items,
      });
    }
  }

  onConfirm() {
    const {
      onConfirm,
      proceed,
    } = this.props;

    if (typeof onConfirm === 'function') {
      onConfirm({...this.props, items: this.state.selected}, this);
    } else {
      proceed(this.state.selected);
    }
  }

	render() {
		const {
      show,
      proceed,
      dismiss,
      cancel,
      headerTitle,
      headerIcon,
      selectMultiple,
      onConfirm,
    } = this.props;

    const {
      selected,
    } = this.state;

    const hasFooter = selectMultiple;
    const isSelectedSortbale = selectMultiple;

    let footerButtons = []

    footerButtons = [
      {
        title: __('Confirm ({number})', 'SelectItemModal', { number: selected.length }),
        className: 'btn btn-primary pull-right',
        onClick: ()=>{
          if(typeof(onConfirm) == 'function'){
            onConfirm({ ...this.props, selected }, this)
          } else {
            proceed(selected);
          }
        },
      },
    ];

		return (
      <Modal
        isShowingModal={show} // if you want to show it when component mounts, set it true
        className='item-select-modal'
        onCloseModalClick={dismiss}
        fixedWidth={500}
        hasHeader={true}
        headerType="bold" // default, bold
        headerTitle={headerTitle}
        headerIcon={headerIcon} // class for icon tag

        hasFooter={hasFooter}
        footerButtons={footerButtons}
      >
        <ModalContent
          {...this.props}
          onSelect={this._onSelect}
          selected={selected}
          allowDeselect={ALLOW_DESELECT}
          isSelectedSortable={isSelectedSortbale}/>
      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/SelectItem/ModalBody.js